import { useCallback } from 'react';

import { GuidedFileRenameExperience } from '@liscio/common';

import { useTrackEvent } from 'analytics/useTrackEvent';

import { FILE_RENAME_SUGGESTION_TARGET_SELECTOR } from './constants';

export interface FileRenameCoachmarkProps {
  fileUuid: string;
  originalName: string;
  suggestedName: string;
  onDismiss: () => void;
  onSpotlight: () => void;
  targetSelector?: string;
}

export const FileRenameCoachmark = ({
  fileUuid,
  originalName,
  suggestedName,
  onDismiss,
  onSpotlight,
  targetSelector = FILE_RENAME_SUGGESTION_TARGET_SELECTOR,
}: FileRenameCoachmarkProps) => {
  const trackEvent = useTrackEvent();
  const handleShown = useCallback(() => {
    trackEvent('rename_coachmark_shown', {
      source: 'onboarding',
      onboarding_step: 'rename_coachmark_shown',
    });
  }, [trackEvent]);

  return (
    <GuidedFileRenameExperience
      fileUuid={fileUuid}
      originalName={originalName}
      suggestedName={suggestedName}
      target={targetSelector}
      onDismiss={onDismiss}
      onComplete={onSpotlight}
      onShown={handleShown}
      collapseOnDismiss={false}
    />
  );
};
